import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Subscription } from 'rxjs';

import { CourtBookingEventDetailsModel } from '@bayclubs/court-booking-employee-api';

import { CancelCourtEventLauncherService } from '@court-event-modals/court-event-modals.module';
import { CourtEventNoteSaveLauncherService, SaveCourtEventNoteSuccessAction } from '@court-event-note-save/court-event-note-save.module';
import { ChangePlayerInputModel, ChangePlayerLauncherService } from '@players/players.module';

import { CourtEventDetailsFacade } from '../../+store/court-event-details.facade';

@Component({
    selector: 'app-court-booking-item-details',
    templateUrl: './court-booking-item-details.component.html',
    styleUrls: ['./court-booking-item-details.component.scss'],
    standalone: false
})
export class CourtBookingItemDetailsComponent implements OnInit, OnDestroy {
    @Input() courtEventId: string;

    courtBooking$ = this.courtEventDetailsFacade.courtBookingDetails$;

    private subscriptions: Subscription = new Subscription();

    constructor(
        private courtEventDetailsFacade: CourtEventDetailsFacade,
        private playersChangeLauncher: ChangePlayerLauncherService,
        private cancelCourtEventLauncherService: CancelCourtEventLauncherService,
        private courtEventNoteSaveLauncherService: CourtEventNoteSaveLauncherService,
        private actions$: Actions
    ) { }

    ngOnInit(): void {
        this.courtEventDetailsFacade.loadCourtBookingDetails(this.courtEventId);

        this.subscriptions.add(
            this.actions$.pipe(ofActionSuccessful(SaveCourtEventNoteSuccessAction)).subscribe(() => {
                this.courtEventDetailsFacade.loadCourtBookingDetails(this.courtEventId);
            })
        );
    }

    ngOnDestroy(): void {
        this.courtEventDetailsFacade.clearLoadedCourtBookingDetails();

        this.subscriptions.unsubscribe();
    }

    onNoShowAllClicked() {
        this.courtEventDetailsFacade.noShowAllCourtBooking(this.courtEventId);
    }

    onCheckInAllClicked() {
        this.courtEventDetailsFacade.checkInAllCourtBooking(this.courtEventId);
    }

    onCancelClicked() {
        this.cancelCourtEventLauncherService.openCancelCourtBookingModal(
            this.courtEventId,
            () => this.courtEventDetailsFacade.loadCourtBookingDetails(this.courtEventId)
        );
    }

    onChangePlayer(personId: string) {
        const courtBooking = this.courtEventDetailsFacade.getCourtBookingDetailsSnapshot();

        this.playersChangeLauncher.openPlayersChangeModal(
            {
                playerId: personId,
                courtId: courtBooking.data.court.courtId,
                courtBookingId: courtBooking.data.courtEventId,
                categoryCode: courtBooking.data.categoryOptions.category.code,
                date: courtBooking.data.date,
                duration: courtBooking.data.timeToInMinutes - courtBooking.data.timeFromInMinutes
            } as ChangePlayerInputModel,
            () => this.courtEventDetailsFacade.loadCourtBookingDetails(this.courtEventId)
        );
    }

    onCheckInPlayer(personId: string) {
        this.courtEventDetailsFacade.checkInPlayerCourtBooking(this.courtEventId, personId);
    }

    onAddNote(): void {
        this.courtEventNoteSaveLauncherService.openCourtNoteSave({ courtEventId: this.courtEventId });
    }

    public isAnyNote(courtBooking: CourtBookingEventDetailsModel): boolean {
        return courtBooking.notes?.length > 0;
    }
}
